import React, {useEffect} from 'react';
import {Container, Grid, Icon, Paper, Typography} from "@mui/material";
import {lightBlue} from "@mui/material/colors";
import PrimaryButton from "../../Common/PrimaryButton";
import {styled} from "@mui/material/styles";
import SecondaryButton from "../../Common/SecondaryButton";
import {useDispatch, useSelector} from "react-redux";
import {setDealerActivities} from "../../../redux/actions/transactionActions";
import {useHistory} from "react-router-dom";
import {setTotalActivitiesFH} from "../../../redux/actions/totalActions";
import {format, parse} from "date-fns";

const PREFIX = 'ActivityCard';
const classes = {
    root: `${PREFIX}-root`,
    container: `${PREFIX}-container`,
    tripImage: `${PREFIX}-trip-image`,
    status: `${PREFIX}-status`,
    hold: `${PREFIX}-hold`,
    waiting: `${PREFIX}-waiting`,
    paid: `${PREFIX}-paid`,
    tripTitle: `${PREFIX}-tripTitle`,
    tripDetailsContainer: `${PREFIX}-tripDetailsContainer`,
    tripDetails: `${PREFIX}-tripDetails`,
    footerInfo: `${PREFIX}-footerInfo`,
}
const PaperTrip = styled(Paper)(({theme}) => ({
    [`&.${classes.root}`]: {
        maxWidth: '900px',
        margin: 10,
    },
    [`& .${classes.status}`]: {
        color: 'white',
        padding: '5px',
        textTransform: 'uppercase',
        fontWeight: '600',
        fontSize: '1.4rem',
        letterSpacing: '1.2px',
    },
    [`& .${classes.container}`]: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100%',
    },
    [`& .${classes.tripImage}`]: {
        objectFit: 'cover',
        height: '100%',
    },[`& .${classes.hold}`]: {
        backgroundColor: 'lightgray',
    },
    [`& .${classes.waiting}`]: {
        backgroundColor: theme.palette.warning.main,
    },
    [`& .${classes.paid}`]: {
        backgroundColor: theme.palette.success.main,
    },
    [`& .${classes.tripTitle}`]: {
        fontSize: '2.4rem',
        letterSpacing: '1.2px'
    },
    [`& .${classes.tripDetailsContainer}`]: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100%',
        textAlign: 'center',
        paddingLeft:15
    },
    [`& .${classes.tripDetails}`]: {
        fontSize: '1.2rem',
        marginLeft: '5px'
    },
    [`& .${classes.footerInfo}`]: {
        fontWeight: '600'
    }
}))
const ActivityCard = ({activity, showTotal, addOrRemove}) => {
    const {extra} = useSelector(state => state.transactions);
    const totals = useSelector(state => state.totalsExtras);
    const dispatch = useDispatch();
    const history = useHistory();

    const currentValue = extra[activity.id] || '';

    // const handlerActivity = (availability) => {
    //     const tempId = availability?.id ?? `temp_${Date.now()}`;
    //     dispatch(setDealerActivities(activity.company, activity.id, tempId, availability, availability !== ''));
    // };

    const handleBook = (value) => {
        // handlerActivity(value);
        history.push(`/booking/day-trips/${activity.id}/book`);
    };

    useEffect(() => {
        dispatch(setTotalActivitiesFH())
    }, []);


    return (
        <PaperTrip className={classes.root} elevation={3} sx={{mx: {xs: '1.6rem', lg: '0'}}}>
            <Grid container>
                <Grid item sm={12} md={4} style={{width: '100%'}}>
                    <div className={classes.container}>
                        <img alt={activity['name']} width={'100%'} className={'summaryImage'} src={activity['image']}/>
                    </div>
                </Grid>
                <Grid item sm={12} md={8}>
                    <Container style={{margin: '10px', padding:20}}>
                        <Typography variant="h3" className={classes.tripTitle}>
                            {activity['name']}
                        </Typography>
                        <Grid container spacing={3}>
                            <Grid item className={classes.tripDetailsContainer} xs={12} sm={12} md={8}>
                                <Typography variant="h5" align="left" style={{padding: '10px 12px 10px'}}>
                                    {activity['description'].split('##More Information')[0]}
                                </Typography>
                            </Grid>
                            <Grid item className={classes.tripDetailsContainer} xs={12} sm={12} md={4}>
                                <Typography variant="h5" align="left" style={{padding: '10px 12px 10px', width: '100%',margin: 'auto'}}>
                                    <span className={classes.tripDetails} style={{display: 'flex', fontSize: '15px', alignItems: 'center', justifyContent: 'center'}}>
                                        <span style={{fontWeight:'bold', color: lightBlue[500]}} className={'tripInfoIcon'}>$</span>
                                        {`${parseFloat(activity['price']).formatMoney(0)}/retail`}
                                    </span>
                                </Typography>
                                {addOrRemove === 1 && <>
                                    {!currentValue ? (
                                        <PrimaryButton sx={{width:'80%'}}
                                                       onClick={() => handleBook(true)}>Book</PrimaryButton>
                                    ) : (
                                        <SecondaryButton sx={{width:'80%'}}
                                                         onClick={() => handlerActivity(false)}>Remove</SecondaryButton>
                                    )}
                                </>
                                }
                                {showTotal ===1 && totals && totals.activityItems && totals.activityItems.length>0 && totals.activityItems.filter((item)=> item.id===activity.id).map((item)=>
                                    <Typography variant="h5" align="left" style={{padding: '10px 12px 10px'}}>
                                        {format(parse(item.date, "yyyy-MM-dd'T'HH:mm:ss", new Date()), 'LLL d')} - {format(parse(item.date, "yyyy-MM-dd'T'HH:mm:ss", new Date()), 'h:mm a')} > {item.pax} Pax
                                    </Typography>)}
                            </Grid>
                        </Grid>
                    </Container>
                </Grid>
            </Grid>
        </PaperTrip>
    );
};

export default ActivityCard;